"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavingsSchema = void 0;
const zod_1 = require("zod");
const SavingsSchema = zod_1.z.object({
    amout: zod_1.z.number(),
    percentageOfBonus: zod_1.z.number(),
});
exports.SavingsSchema = SavingsSchema;
